import { render, staticRenderFns } from "./workTicketRelevanceOther.vue?vue&type=template&id=47bca5f2&scoped=true&"
import script from "./workTicketRelevanceOther.vue?vue&type=script&lang=ts&"
export * from "./workTicketRelevanceOther.vue?vue&type=script&lang=ts&"
import style0 from "./workTicketRelevanceOther.vue?vue&type=style&index=0&id=47bca5f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bca5f2",
  null
  
)

export default component.exports